import React, { useContext, useEffect, useState } from "react";
import FormSkel from "../../../../components/Modals/FormSkel";
import { IndexedDbContext } from "../../../../db/indexedDbProvider";
import cursor from "lodash/seq";
import axios from "axios";
import { API_URL } from "../../../../config/config";
import moment from "moment/moment";

const MachineState = ({ machineId, header, closeForm }) => {
  const [machineProducts, setMachineProducts] = useState([]);
  const { IndexedDBAsyncContext } = useContext(IndexedDbContext);
  const [dateTime, setDateTime] = useState(null);
  const isHAP = sessionStorage.getItem("clientId") === "hap";
  const getMachineProductsOffline = async (machineId) => {
    const db = IndexedDBAsyncContext.db;
    const trx = db.transaction(["machineProducts"], "readonly");
    const res = [];
    for await (const i of trx.store) {
      if (cursor.value?.MachineId === machineId) {
        res.push(i);
      }
    }
  };
  const getMachineProductsOnline = async (machineId) => {
    console.log(machineId);
    return axios
      .post(`${API_URL}/api/mobile/machine-products`, {
        machineId: [machineId],
      })
      .then((res) => {
        moment.locale("pl");
        setDateTime(moment().format("YYYY-MM-DD HH:mm:ss"));
        return res.data;
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    getMachineProductsOnline(machineId).then((machineProducts) => {
      setMachineProducts(machineProducts);
    });
  }, []);
  const MachineProduct = (machineProduct) => (
    <div
      className="mt-2 d-flex justify-content-between"
      key={machineProduct.id}
    >
      <input
        type={"text"}
        disabled={true}
        style={{ width: "20%" }}
        className={"mr-2 form-control"}
        value={machineProduct.MachineFeederNo}
      />
      <input
        type={"text"}
        disabled={true}
        style={{ width: "45%" }}
        className={"mr-2 form-control"}
        value={machineProduct.ProductName}
      />
      <input
        type={"text"}
        disabled={true}
        style={{ width: "15%" }}
        className={"mr-2 form-control"}
        value={machineProduct.LastItemCount}
      />
      {isHAP ? (
        <input
          type={"text"}
          disabled={true}
          style={{ width: "20%" }}
          className={"mr-2 form-control"}
          value={machineProduct.AuthCode}
        />
      ) : (
        <input
          type={"text"}
          disabled={true}
          style={{ width: "20%" }}
          className={" form-control"}
          value={machineProduct.MaxItemCount}
        />
      )}
    </div>
  );
  return (
    <FormSkel
      headerText={
        <div>
          <div>{header}</div>
          <div>Stan na: {dateTime}</div>
        </div>
      }
      handleClose={closeForm}
      noFooter={true}
    >
      <div className={"d-flex align-self-center justify-content-between"}>
        <div
          className={"d-flex mr-2 justify-content-center align-items-center"}
          style={{ width: isHAP ? "15%" : "20%", padding: ".375rem .75rem" }}
        >
          Nr wyboru
        </div>
        <div
          className={"d-flex mr-2 justify-content-center align-items-center"}
          style={{ width: isHAP ? "30%" : "45%", padding: ".375rem .75rem" }}
        >
          Nazwa
        </div>
        <div
          className={"d-flex mr-2 justify-content-center align-items-center"}
          style={{ width: isHAP ? "10%" : "15%", padding: ".375rem .75rem" }}
        >
          Stan
        </div>

        {isHAP ? (
          <div
            className={"d-flex mr-2 justify-content-center align-items-center"}
            style={{ width: isHAP ? "10%" : "15%", padding: ".375rem .75rem" }}
          >
            Kod autoryzujący
          </div>
        ) : (
          <div
            className={"d-flex justify-content-center align-items-center"}
            style={{ width: isHAP ? "15%" : "20%", padding: ".375rem .75rem" }}
          >
            Pojemność
          </div>
        )}
      </div>
      {machineProducts && machineProducts.map((i) => MachineProduct(i))}
    </FormSkel>
  );
};

export default MachineState;
